import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";
import { setRoleProps } from "../../components/role/roleModule";
import axios from "axios";

type updatePinResponse = { "code": string, "message": string, "pinUpdated": { "message": string, "result": {}, "success": boolean }, "success": boolean }

export type LocationProps = {
    "locationName": string,
    "id": number,
    "isDefault": boolean,
    "timeZone": string,
    "isActive": boolean,
    "medium": string,
    "addressId": number
}
interface intialState {
    staffList: {
        ActiveStaffList: { error: string, value: User[] | null, isLoading: boolean, count?: string },
        InActiveStaffList: { error: string, value: User[] | null, isLoading: boolean, count?: string }
    },
    verifyEmail: { error: string | null, value: verifyEmailType | null, loading: boolean }
}

export interface LocationWithSelected extends LocationProps {
    selected: boolean;
}



export type StaffDetailsResponse = {
    userDetails: {
        userdetails: staffType,
        firstName: string;
        lastName: string | null;
        email: string | null;
        storeId: number;
        phone: string;
        countryCode: number,
    };
    message: string;
    statusCode: string;
    success: boolean;
};


export type staffType =
    {
        userId: string;
        id: number;
        firstName: string;
        lastName: string | null;
        email: string | null;
        storeId: number;
        phone: string;
        emailNotification: string | null;
        smsNotification: boolean;
        role: {
            id: number;
            role: string;
            code: string;
            name: string
        };
        "target": {
            "targetId": number,
            "dailyTarget": number,
            "weeklyTarget": number,
            "monthlyTarget": number
        },
        countryCode: string | number
        userLocationsMappings: {
            locationId: number;
            id: number,
            name: string
        }[],
        imageUrl: string
    };
export type verifyEmailType = {
    "emailExists": boolean,
    "code": string,
    "message": string,
    "success": true
}

type StaffResponse = {
    users: {
        users: User[];
        totalcount: string
    };
};

export type User = {
    userId: string;
    id: number;
    firstName: string;
    email: string;
    storeId: number;
    phone: string;
    emailNotification: boolean;
    smsNotification: boolean;
    pushNotification: boolean;
    isActive: boolean;
    countryCode: number;
    imageUrl: string;
    role: {
        role_id: number;
        role: string;
        code: string;
    };
    target: {
        targetId: number;
        dailyTarget: number;
        weeklyTarget: number;
        monthlyTarget: number;
    };
    userLocationsMappings: {
        locationId: number;
    }[];
};


type PosStaffTargetHistoryResponse = {
    posStaffTargetHistory: {
        id: number;
        user_id: string;
        store_id: number;
        daily_target: string;
        weekly_target: string;
        monthly_target: string;
        achieved_daily_target: string | null;
        achieved_weekly_target: string | null;
        achieved_monthly_target: string | null;
    }[];
    statusCode: string;
    message: string;
    success: boolean;
};

export interface GetAllStaffListPayloadProps {
    roleId: string,
    data: {
        limit: number,
        offset: number,
        filterData: string | null,
        searchText: string,
    },
    isActive: boolean
    storeId: number
}

export interface AddOrUpdateStaffDetailsPayloadProps {
    firstName: string;
    inventoryLocations: number[];
    role: {
        id: number;
        code: string;
    };
    contactNumber: string;
    countryCode: string | number;
    isFromMail: null;
    clientId: string | undefined;
    isActive: boolean;
    target: {
        dailyTarget: number;
        weeklyTarget: number;
        monthlyTarget: number;
    };
    profileImage: {
        fileName: string;
        fileUrl: string;
        ext: string;
        image: string;
        url: string;
    }[] | null;
}


const initialState: intialState =
{
    staffList: { ActiveStaffList: { error: '', value: null, isLoading: false }, InActiveStaffList: { error: '', value: null, isLoading: false } },
    verifyEmail: { error: null, value: null, loading: false }
}


//The staff list screen loads every staff once and does search, filter and pagination locally,
//so every list fetch (screen and middleware refetch) must use this limit
export const STAFF_LIST_LIMIT = 1000

export const getAllStaffList = createAsyncThunk('staff/list', ({ roleId, isActive, data, storeId }: GetAllStaffListPayloadProps) => {
    let Url = HttpRoutingService.replaceUrl(API.staffList, { roleId, isActive, storeId })
    return HttpRoutingService.getMethod<StaffResponse>(Url, data)
})

export const addNewStaff = createAsyncThunk('staff/add', ({ data, registration, pin, storeId }: { data: AddOrUpdateStaffDetailsPayloadProps, registration: string, pin: string, storeId: number }) => {
    let Url = HttpRoutingService.replaceUrl(API.addStaff, { storeId })
    return HttpRoutingService.postMethod(Url, data, {}, 'v2/', { registration, pin })
})


export const updatePin = createAsyncThunk("staff/updatePinApi", async ({ registration, pin }: { registration: string, pin: string }, { rejectWithValue }) => {
    try {
        const response = await HttpRoutingService?.putMethod<updatePinResponse>("auth/update/pin", { status: true }, null, "v2/", { registration, pin })
        return response
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            return rejectWithValue(error.response);
        }
    }
})

export const changeStatus = createAsyncThunk('staff/status', ({ staffId, data, storeId }: { staffId: string, data: { isActive: boolean }, storeId: number }) => {
    let Url = HttpRoutingService.replaceUrl(API.staffStatus, { storeId: storeId, staffId: staffId })
    return HttpRoutingService.patchMethod(Url, data, null, 'v2/')
})

export const getOneStaffDetails = createAsyncThunk('staff/details', ({ staffId }: { staffId: string }) => {
    let Url = HttpRoutingService.replaceUrl(API.staffDetails, { storeId: config.storeId, staffId: staffId })
    return HttpRoutingService.getMethod<StaffDetailsResponse>(Url, null, 'v2/')
})

export const updateStaffDetails = createAsyncThunk('staff/update', ({ staffId, data, storeId }: { staffId: string, data: AddOrUpdateStaffDetailsPayloadProps, storeId: number }) => {
    let Url = HttpRoutingService.replaceUrl(API.updateStaff, { storeId: storeId, staffId: staffId })
    return HttpRoutingService.putMethod(Url, data, null, 'v2/')
})

export const deleteStaff = createAsyncThunk('staff/delete', ({ staffId, storeId, data }: { staffId: string, storeId: number, data: { isDeleted: boolean } }) => {
    const Url = HttpRoutingService.replaceUrl(API.deleteStaff, { staffId: staffId, storeId: storeId })
    return HttpRoutingService.putMethod(Url, data)
})

export const verifyEmail = createAsyncThunk('staff/verifyEmail', ({ data }: { data: { email: string } }) => {
    return HttpRoutingService.postMethod<verifyEmailType>(API.emailVerify, data)
})

export const getOneStaffHistoryDetails = createAsyncThunk('staff/targetDetails', ({ staffId }: { staffId: number }) => {
    const Url = HttpRoutingService.replaceUrl(API.staffTarget, { staffId: staffId, storeId: config.storeId })
    return HttpRoutingService.getMethod<PosStaffTargetHistoryResponse>(Url, { id: staffId })
})


const staffSlice = createSlice({
    initialState: initialState,
    name: 'staff',
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getAllStaffList.pending, (state, action) => {
            const { isActive } = action.meta.arg
            const screenKey = isActive ? 'ActiveStaffList' : 'InActiveStaffList'
            state.staffList[screenKey].isLoading = true
        })
            .addCase(getAllStaffList.fulfilled, (state, action) => {
                const { data: { offset, }, isActive } = action.meta.arg
                const screenKey = isActive ? 'ActiveStaffList' : 'InActiveStaffList'
                state.staffList[screenKey].isLoading = false
                state.staffList[screenKey].count = action?.payload?.users?.totalcount
                if (offset > 0) {
                    if (action.payload.users.users)
                        state.staffList[screenKey].value = [...state?.staffList?.[screenKey]?.value!, ...action?.payload.users?.users]
                } else {
                    state.staffList[screenKey].value = action?.payload?.users?.users || []
                }
            })
            .addCase(getAllStaffList.rejected, (state, action) => {
                const { isActive } = action.meta.arg
                const screenKey = isActive ? 'ActiveStaffList' : 'InActiveStaffList'
                state.staffList[screenKey].isLoading = false
                state.staffList[screenKey].error = action.error.message as string
            })
            // Update the lists straight away so the UI is correct while the middleware refetches them
            .addCase(changeStatus.fulfilled, (state, action) => {
                const { staffId, data: { isActive } } = action.meta.arg
                const fromKey = isActive ? 'InActiveStaffList' : 'ActiveStaffList'
                const toKey = isActive ? 'ActiveStaffList' : 'InActiveStaffList'
                const staff = state.staffList[fromKey].value?.find((item) => item?.userId === staffId)
                if (state.staffList[fromKey].value) {
                    state.staffList[fromKey].value = state.staffList[fromKey].value!.filter((item) => item?.userId !== staffId)
                }
                if (staff && state.staffList[toKey].value) {
                    state.staffList[toKey].value = [{ ...staff, isActive }, ...state.staffList[toKey].value!.filter((item) => item?.userId !== staffId)]
                }
            })
            .addCase(deleteStaff.fulfilled, (state, action) => {
                const { staffId } = action.meta.arg
                const listKeys = ['ActiveStaffList', 'InActiveStaffList'] as const
                listKeys.forEach((key) => {
                    if (state.staffList[key].value) {
                        state.staffList[key].value = state.staffList[key].value!.filter((item) => item?.userId !== staffId)
                    }
                })
            })
        builder.addCase(verifyEmail.pending, (state, action) => {
            state.verifyEmail.loading = true
        })
            .addCase(verifyEmail.fulfilled, (state, action) => {
                state.verifyEmail.loading = false
                state.verifyEmail.value = action?.payload
            })
            .addCase(verifyEmail.rejected, (state, action) => {
                state.verifyEmail.loading = false
            })
    }
})
export default staffSlice.reducer